import { useEffect } from "react";
import { Language } from "../../../../rest/models";
import { useAppDispatch } from "../../../../store/hooks";
import { bookEditorActions } from "../slice";
import { RestObjectDDL } from "../../../../rest/components/RestObjectDDL";
import { Valid } from "../../../CommonComponents";

export function SourceLanguageEdit(props: Props)
{
    const appDispatch = useAppDispatch();

    const slid = props.source_language;
    useEffect(function()
    {
        //Make sure source language is in the booklanguage_set.
        appDispatch(bookEditorActions.addBookLanguage(slid));
    }, [appDispatch, slid]);

    return (
        <div className='ernots_SourceLanguageEdit'>
            <legend>Languages</legend>
            <label htmlFor='source_language'>Source Language</label>
            <Valid bValid={slid} children='A source language is required.'/>
            <RestObjectDDL
                id='source_language'
                name='source_language'
                modelClass={Language}
                property='name'
                hasEmptyOption={true}
                selection={slid}
                required={true}
                handleChange={val => appDispatch(bookEditorActions.setSourceLanguage(val))}/>
        </div>);
}

interface Props
{
    source_language: string;
}